<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="e3-svg" :width="Number(size)" :height="Number(size)" viewBox="0 0 24 24">
        <path fill="currentColor" d="M19.36 6.77L17.23 4.64 12 9.88 6.77 4.64 4.64 6.77 9.88 12 4.64 17.23 6.77 19.36 12 14.12 17.23 19.36 19.36 17.23 14.12 12 19.36 6.77z"/>
    </svg>
</template>

<script>
export default {
    name: 'CloseIcon',
    props: {
        size: {
            type: [String, Number],
            default: 24
        }
    }
};
</script>
